import React from "react";
import { Modal, StackLayout } from "@leagueplatform/genesis-core";

type Props = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: number;
};

export const BaseModalContainer = ({
  children,
  footer = null,
  maxWidth = 583,
}: Props) => (
  <Modal.Content
    showCloseButton
    padding="$none"
    css={{
      ".GDS-modal": {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth,
        "@mobile": { maxWidth: "100%" },
      },
    }}
  >
    <StackLayout
      spacing="$oneAndHalf"
      horizontalAlignment="stretch"
      css={{ padding: "$oneAndHalf", width: "100%" }}
    >
      {children}
      {footer}
    </StackLayout>
  </Modal.Content>
);
